

 <h1 class="bold">Request from MRP / MIXER -</h1>

   
   
		
   
<div class="container-fluid pt-3">

    <!-- end page title end breadcrumb -->
   
            <div class="row">
                <div class="col-sm-12">
                    <div class="page-title-box">

                        <div class="card">
                            <div class="card-header bg-primary text-center text-white">
                                Request from MRP / MIXER  TO SHOP FLOOR
                            </div>
                            <div class="card-body1">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr class="bg">
                                            <th>
                                             sr.no</th>
                                            <th>OrderNo	</th>
                                            <th>
                                                Material</th>
                                            <th>Description	</th>
                                            <th>
                                                QtyReq</th>
                                            <th>Balance</th>
                                            <th>
                                                Process</th>
                                            <th>	Action</th>
                                          
                                        
                                        </tr>
                                    </thead>
                                   
                                    <tbody>

                                        <tr>
                                            <th scope="row">1</th>
                                            <td> 21120075</td>
                                            <td>	CLEAR BOPP	</td>
                                            <td>CLEAR BOPP [1200mm X 15μm]	</td>
                                            <td>920.34075275591	</td>
                                            <td>920.34075275591	</td>
                                            <td>PRINTING</td>
                                            <td>  <button class="button-7" role="button">Issue</button></td>
                                         
                                          
                                        </tr>
                                        <tr>
                                            <th scope="row">2</th>
                                            <td> 21120055</td>
                                            <td>	CLEAR BOPP	</td>
                                            <td>CLEAR BOPP [1200mm X 15μm]	</td>
                                            <td>920.34075275591	</td>
                                            <td>920.34075275591	</td>
                                            <td>PRINTING</td>
                                            <td>  <button class="button-7" role="button">Issue</button></td>
                                         
                                        </tr>
                                        <tr>
                                            <th scope="row">3</th>
                                            <td> 21120855</td>
                                            <td>	CLEAR BOPP	</td>
                                            <td>CLEAR BOPP [1200mm X 15μm]	</td>
                                            <td>920.34075275591	</td>
                                            <td>920.34075275591	</td>
                                            <td>PRINTING</td>
                                            <td>  <button class="button-7" role="button">Issue</button></td>
                                         
                                        </tr>
                                        <tr>
                                            <th scope="row">4</th>
                                            <td> 21120045</td>
                                            <td>	CLEAR BOPP	</td>
                                            <td>CLEAR BOPP [1200mm X 15μm]	</td>
                                            <td>920.34075275591	</td>
                                            <td>920.34075275591	</td>
                                            <td>PRINTING</td>
                                            <td>  <button class="button-7" role="button">Issue</button></td>
                                         
                                        </tr>
                                        <tr>
                                            <th scope="row">5</th>
                                            <td> 21120059</td>
                                            <td>	CLEAR BOPP	</td>
                                            <td>CLEAR BOPP [1200mm X 15μm]	</td>
                                            <td>920.34075275591	</td>
                                            <td>920.34075275591	</td>
                                            <td>PRINTING</td>
                                            <td>  <button class="button-7" role="button">Issue</button></td>
                                         
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
                
            </div><!-- container -->
        </div>
    